import { createRoutine } from 'redux-saga-routines';

export const fetchReservationOrderedItemsReport = createRoutine(
  'FETCH_RESERVATION_ORDERED_ITEMS_REPORT'
);
